import React from 'react';
import Modal from '../../UI/Modal/Modal';
import classes from './OpenSourceModal.module.css';

const OpenSourceModal = props => {
  return (
    <Modal onClose={props.onClose} onColor={props.items.color}>
      <div onClick={props.onClose} className={classes.closebtn}>
        <ion-icon name="close"></ion-icon>
      </div>
      <section className={classes['modal-top']}>
        <div className={classes}>
          <img
            className={classes['modal-image']}
            src={props.items.imageSrc}
            alt="img"
          />
        </div>
        <h1
          style={{ color: props.items.fontColor }}
          className={classes['modal-title']}
        >
          {props.items.title}
        </h1>
      </section>
      <section className={classes['modal-bottom']}>
        <p
          style={{ color: props.items.fontColor }}
          className={classes['modal-description']}
        >
          {props.items.headline}
          <br />
          {props.items.description}
        </p>
        <a
          href={props.items.link}
          target="_blank"
          rel="noreferrer"
          className={classes.link}
        >
          <span className={classes.span}></span>Visit Website{' '}
          <svg
            className={classes.svg}
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            viewBox="0 0 24 24"
            strokeLinecap="round"
            strokeLinejoin="round"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </section>
    </Modal>
  );
};

export default OpenSourceModal;
